const $       = require('jquery');
const eventer = require('./eventer');

const api = { all: eventer({}), readcube: eventer({}) };

function readcubeOrigin(origin) {
  if (!/readcube\.com(:\d+)?$/.test(origin || '')) {
    return false;
  }
  return true;
}

$(window).on('message', function(e) {
  while (e.originalEvent) e = e.originalEvent;

  if (e.data && e.data.type) {
    if (readcubeOrigin(e.origin)) {
      api.readcube.trigger(e.data.type, [e.data]);
    }
    api.all.trigger(e.data.type, [e.data]);
  }
});

window.popupMessage = function(data) {
  api.all.trigger(data.type, [data]);
};

module.exports = api;
